var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaresTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14828_4389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 6.5H4C3.00544 6.5 2.05161 6.85558 1.34835 7.48851C0.645088 8.12145 0.25 8.97989 0.25 9.875L0.25 30.125C0.25 31.0201 0.645088 31.8786 1.34835 32.5115C2.05161 33.1444 3.00544 33.5 4 33.5H36.5C37.4946 33.5 38.4484 33.1444 39.1516 32.5115C39.8549 31.8786 40.25 31.0201 40.25 30.125V9.875C40.25 8.97989 39.8549 8.12145 39.1516 7.48851C38.4484 6.85558 37.4946 6.5 36.5 6.5ZM18.0625 20.1012L12.75 25.625L7.4375 20.1012C6.83041 19.4308 6.49889 18.5924 6.49889 17.7275C6.49889 16.8626 6.83041 16.0242 7.4375 15.3538C7.71169 15.0484 8.05829 14.8021 8.45193 14.6329C8.84557 14.4637 9.27627 14.3759 9.7125 14.3759C10.1487 14.3759 10.5794 14.4637 10.9731 14.6329C11.3667 14.8021 11.7133 15.0484 11.9875 15.3538C12.3406 15.723 12.6008 16.1567 12.75 16.625C12.8959 16.1487 13.1562 15.7071 13.5125 15.3313C13.7867 15.0259 14.1333 14.7796 14.5269 14.6104C14.9206 14.4412 15.3513 14.3534 15.7875 14.3534C16.2237 14.3534 16.6544 14.4412 17.0481 14.6104C17.4417 14.7796 17.7883 15.0259 18.0625 15.3313C18.676 16.0034 19.0113 16.8464 19.0113 17.7163C19.0113 18.5861 18.676 19.4291 18.0625 20.1012ZM32.75 26.75H21.5C21.1685 26.75 20.8505 26.6315 20.6161 26.4205C20.3817 26.2095 20.25 25.9234 20.25 25.625C20.25 25.3266 20.3817 25.0405 20.6161 24.8295C20.8505 24.6185 21.1685 24.5 21.5 24.5H32.75C33.0815 24.5 33.3995 24.6185 33.6339 24.8295C33.8683 25.0405 34 25.3266 34 25.625C34 25.9234 33.8683 26.2095 33.6339 26.4205C33.3995 26.6315 33.0815 26.75 32.75 26.75Z",
    fill: "#73007D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14828_4389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaresTotal);
export default __webpack_public_path__ + "static/media/cares_total.c9e525d6cf30d8a485b7b45664b12584.svg";
export { ForwardRef as ReactComponent };